import { Box, Text, Flex } from "@chakra-ui/react";
import { Control, UseFormSetValue } from "react-hook-form";
import { UseFormWatch } from "react-hook-form";
import ButtonPlus from "./components/ButtonPlus";
import ComposicaoItem from "./components/ComposicaoItem";
import { FormAcordo } from "features/acordo/typings";
import { FormAcordoComposicao } from "core/features/acordo/typings";
import { useRef } from "react";

interface FormComposicoesPagamentosProps {
  control: Control<FormAcordo>;
  watch: UseFormWatch<FormAcordo>;
  setValue: UseFormSetValue<FormAcordo>;
  canEditComposicoes?: boolean;
}

function FormComposicoesPagamentos({
  control,
  setValue,
  watch,
  canEditComposicoes = true,
}: FormComposicoesPagamentosProps) {
  const tempIdIncrement = useRef(0);
  return (
    <Flex flexDir="column" mt="32px">
      <Box w="full">
        <Flex align="center" mb={"32px"}>
          <Text fontSize="18px" fontWeight={"bold"}>
            Composições
          </Text>
          {canEditComposicoes ? (
            <ButtonPlus
              onClick={() => {
                setValue("composicoes", [
                  ...(watch("composicoes") ?? []),
                  {
                    added: true,
                    tempId: `${new Date().getTime().toString()}${
                      tempIdIncrement.current
                    }`,
                  } as any,
                ]);

                tempIdIncrement.current += 1;
              }}
            />
          ) : null}
        </Flex>

        <Flex flexDir="column" gap={4}>
          {watch("composicoes").map(
            (composicao: FormAcordoComposicao, index: number) => (
              <ComposicaoItem
                canEditComposicoes={canEditComposicoes}
                setValue={setValue}
                composicoes={watch("composicoes")}
                key={
                  composicao.added
                    ? composicao.tempId
                    : composicao.categoriaFinanceiraId
                }
                index={index}
                control={control}
              />
            )
          )}
        </Flex>
      </Box>
    </Flex>
  );
}

export default FormComposicoesPagamentos;
